
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface DialogFooterProps {
  onClose: () => void;
  onSchedule: () => void;
  isScheduleDisabled: boolean;
  isProcessing?: boolean;
}

export const DialogFooter: React.FC<DialogFooterProps> = ({ 
  onClose, 
  onSchedule, 
  isScheduleDisabled,
  isProcessing = false
}) => {
  return (
    <div className="flex justify-end gap-2 mt-6">
      <Button
        onClick={onClose}
        variant="outline"
        className="bg-transparent border-[#223342] text-white hover:bg-[#1A2233] hover:text-white"
        disabled={isProcessing}
      >
        Cancelar
      </Button>
      <Button
        onClick={onSchedule}
        disabled={isScheduleDisabled}
        className="bg-[#00B6F0] hover:bg-[#0090C0] text-black"
      >
        {isProcessing ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Processando...
          </>
        ) : (
          'Agendar e Pagar'
        )}
      </Button>
    </div>
  );
};
